export const flipCard = `
.flipcard-text {
  text-align: center;
}
`;
